import { z } from 'zod';

const FormalBroadbandPricingSchema = z.object({
  circuit: z.number(),
  id: z.string().uuid(),
  internet_access_recovery: z.number(),
  ip: z.number(),
  modem: z.number(),
  service_activation: z.number(),
  total_mrc: z.number(),
});

const FormalBroadbandProductSchema = z.object({
  bandwidth_download: z.string(),
  bandwidth_upload: z.string(),
  formal_broadband_pricing: FormalBroadbandPricingSchema,
  id: z.string().uuid(),
  ip_type: z.string(),
});

const FormalDiaPricingSchema = z.object({
  carrier_surcharge_recovery: z.number(),
  circuit: z.number(),
  equipment: z.number(),
  id: z.string().uuid(),
  ip: z.number(),
  service_activation: z.number(),
  total_mrc: z.number(),
});

const FormalDiaProductSchema = z.object({
  access_type: z.string(),
  bandwidth: z.string(),
  formal_dia_pricing: FormalDiaPricingSchema,
  id: z.string().uuid(),
  on_net: z.string(),
  router_added: z.string(),
});

export const FormalProductOfferingsSchema = z.object({
  formal_broadband_product: FormalBroadbandProductSchema.nullable(),
  formal_dia_product: FormalDiaProductSchema.nullable(),
  id: z.string().uuid(),
  ip_block: z.string().nullable(),
  ordered: z.boolean(),
  product_type: z.string(),
  provider: z.string(),
  qty: z.number(),
  term: z.string(),
});

const LocationSchema = z.object({
  address1: z.string(),
  address2: z.string().nullable(),
  city: z.string(),
  formal_products_offerings: z.array(FormalProductOfferingsSchema),
  id: z.string().uuid(),
  state: z.string(),
  zip_code: z.string(),
});

const ResponseSchema = z.object({
  business_unit: z.string(),
  company_id: z.number(),
  customer_name: z.string(),
  email: z.string().email(),
  error_message: z.string().nullable(),
  formal_quote_expires_at: z.string().nullable(),
  id: z.string().uuid(),
  locations: z.array(LocationSchema),
  qe_quote_created_at: z.string(),
  qe_quote_request_id: z.number(),
  quote_name: z.string(),
  quote_status: z.string(),
  requester: z.string(),
});

export default ResponseSchema;

export type QuoteDetailsResponse = z.infer<typeof ResponseSchema>;
export type FormalDiaProduct = z.infer<typeof FormalDiaProductSchema>;
export type FormalBroadbandProduct = z.infer<
  typeof FormalBroadbandProductSchema
>;

export type FormalProductOfferings = z.infer<
  typeof FormalProductOfferingsSchema
>;
